import { AUDIT_ACTION_VALUES, AUDIT_ENTITY_TYPE_VALUES, USER_ROLE_VALUES } from '@cult/domain';
import { z } from 'zod';
import { idField } from './common';
import { UserSummarySchema } from './users';

// A journaled field value: text, a list (core-value ids, attachment filenames) or cleared.
export const AuditValueSchema = z.union([z.string(), z.array(z.string()), z.null()]);
export type AuditValue = z.infer<typeof AuditValueSchema>;

/** Only the fields that changed, keyed by field name. A delete records every field with `to: null`. */
export const AuditChangesSchema = z.record(z.string(), z.object({ from: AuditValueSchema, to: AuditValueSchema }));
export type AuditChanges = z.infer<typeof AuditChangesSchema>;

export const AuditEntityTypeSchema = z.enum(AUDIT_ENTITY_TYPE_VALUES);

export const AuditLogQuerySchema = z.object({
  entityType: AuditEntityTypeSchema,
  entityId: idField.uuid(),
});
export type AuditLogQuery = z.infer<typeof AuditLogQuerySchema>;

export const AuditLogEntrySchema = z.object({
  id: idField,
  action: z.enum(AUDIT_ACTION_VALUES),
  actor: UserSummarySchema,
  // The actor's role when they made the change — tells an author's own edit from an admin override.
  actorRole: z.enum(USER_ROLE_VALUES),
  changes: AuditChangesSchema,
  createdAt: z.string(),
});
export type AuditLogEntry = z.infer<typeof AuditLogEntrySchema>;

export const AuditLogResponseSchema = z.object({
  entries: z.array(AuditLogEntrySchema),
  // Display names for ids found in reference fields (receiver, categoryId, coreValues), resolved at read time.
  labels: z.record(z.string(), z.string()),
});
export type AuditLogResponse = z.infer<typeof AuditLogResponseSchema>;
